import { Location } from 'vue-router';

export interface HealthCheckLocation {
  /** 予約日登録へのロケーション */
  toMakeAppointmentLocation: (params: { healthCheckId: string }) => Location;

  /** 予約完了へのロケーション */
  toCompleteAppointmentLocation: (params: { healthCheckId: string }) => Location;

  /** 健康診断データへのロケーション */
  toHealthCheckDataLocation: () => Location;

  /** 健康診断予約へのロケーション */
  toHealthCheckReservationLocation: () => Location;

  /** 再検査へのロケーション */
  toHealthCheckReExaminationLocation: () => Location;
}

export const useHealthCheckLocation = (): HealthCheckLocation => {
  const toMakeAppointmentLocation = (params: { healthCheckId: string }): Location => {
    return {
      name: 'health-check-appointment-input',
      params,
    };
  };

  const toCompleteAppointmentLocation = (params: { healthCheckId: string }): Location => {
    return {
      name: 'health-check-appointment-complete',
      params,
    };
  };

  const toHealthCheckDataLocation = (): Location => {
    return {
      name: 'health-check-data',
    };
  };

  const toHealthCheckReservationLocation = (): Location => {
    return {
      name: 'health-check-appointment-input',
    };
  };

  const toHealthCheckReExaminationLocation = (): Location => {
    return {
      name: 'health-check-re-examination',
    };
  };

  return {
    toMakeAppointmentLocation,
    toCompleteAppointmentLocation,
    toHealthCheckDataLocation,
    toHealthCheckReservationLocation,
    toHealthCheckReExaminationLocation,
  };
};
